import { omit } from 'lodash';

export const transformPayload = (data) => {
  const { email_address: email } = data;

  const args = {
    ...omit(data, ['email_address']),
    email,
  };

  return args;
};
